import * as p from '@clack/prompts'
import { PassThrough } from 'node:stream'
import { getCurrentCliVersion } from '@cli-utils/paths.js'
import { addVersionToBoxBottomBorder } from '@cli-utils/terminal.js'
import { renderInitBannerArt } from '@next-adapter/templates/renderers/commands/init/banner-art.js'

export function renderInitBanner(): void {
  const output = new PassThrough()
  Object.defineProperty(output, 'columns', { value: process.stdout.columns })

  let box = ''
  output.on('data', (chunk: Buffer) => {
    box += chunk.toString()
  })

  p.box(renderInitBannerArt(), 'Setup your Next.js Dashboard', {
    rounded: true,
    contentAlign: 'center',
    titleAlign: 'center',
    output
  })

  process.stdout.write(addVersionToBoxBottomBorder(box, getCurrentCliVersion()))
}
